import { Balance, Text } from "@sundae/ui-toolkit";
import type { IBalanceProps } from "@sundae/ui-toolkit/dist/types/components/atoms/Balance/Balance";
import { AssetAmount, IAssetAmountMetadata } from "@sundaeswap/asset";
import cx from "classnames";
import { FC, HTMLAttributes, useMemo } from "react";

import { testIds } from "../../constants/testIds.constants";
import { useProfileAppContext } from "../../stores";
import { IAssetMetaData } from "../../types/Asset.types";
import { getAssetName } from "../../utils/assets.utils";

export interface IBalanceWithAssetNameProps
  extends Omit<IBalanceProps, "value">,
    Pick<HTMLAttributes<HTMLSpanElement>, "className"> {
  asset?: IAssetMetaData;
  value: AssetAmount<IAssetAmountMetadata>;
}

const BalanceWithAssetName: FC<IBalanceWithAssetNameProps> = ({
  asset,
  className,
  value,
  privacy,
  showSymbol,
  gradient,
  size,
  variant,
  weight,
  ...balanceProps
}) => {
  const {
    state: { privacyEnabled },
  } = useProfileAppContext();

  const metadata = useMemo(() => {
    return asset ?? value?.metadata;
  }, [asset, value?.metadata]);

  return (
    <Text
      className={cx("inline-flex items-center gap-[2px]", className)}
      size={size}
      tag="span"
      gradient={gradient}
      variant={variant}
    >
      <Balance
        {...balanceProps}
        value={value}
        privacy={privacy ?? privacyEnabled}
        showSymbol={showSymbol}
        size={size}
        variant={variant}
        weight={weight}
        testId={testIds.balanceWithAssetName.value}
      />

      {!showSymbol && !privacy && !privacyEnabled && metadata && (
        <Text
          size={size}
          tag="span"
          variant={variant}
          weight={weight}
          testId={testIds.balanceWithAssetName.assetName}
        >
          {getAssetName(metadata)}
        </Text>
      )}
    </Text>
  );
};

export default BalanceWithAssetName;
